import e from"./isSelect.esm.js";function t(t,s,i){return!(!s.uniqueItems||!s.items||"boolean"==typeof s.items)&&e(t,s.items,i)}export{t as default};
